import { ToastMessageContext } from "lib/contexts/message_context";
import ReportsServices from "lib/services/api/reports/reports";
import MySmsServices from "lib/services/api/sms/my_sms_service";
import { getOrganisationId } from "lib/utils/common_utils";
import React, { useContext, useEffect, useState } from "react";

const useGetSetupFilterOptions = () => {
  const [filterOptions, setFilterOptions] = useState({});
  const message = useContext(ToastMessageContext);

  const getDropdownOptions = async () => {
    try {
      const organisation_id = getOrganisationId();

      const [categoryResponse, userListResponse] = await Promise.all([
        ReportsServices.getCategories({ organisation_id }),
        MySmsServices.getUsersList({ organisation_id }),
      ]);

      const transformedCategoryOptions =
        categoryResponse?.data?.map((category) => {
          return { id: category?.id, value: category?.name };
        }) || [];

      const transformedUserGroupOptions =
        userListResponse?.data?.user_group?.map((user) => {
          return { id: user?.id, value: user?.name };
        }) || [];

      setFilterOptions({
        categories: transformedCategoryOptions,
        user_group: transformedUserGroupOptions,
      });
    } catch (err) {
      message.showToastMessage({
        message: "Something went wrong while fetching options. Try again!",
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getDropdownOptions();
  }, []);

  return filterOptions;
};

export default useGetSetupFilterOptions;
